var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const toEntries = (wixTypography) => Object.entries(wixTypography);
const definitionToCssFont = (def) => def.value.substr(5, def.value.length - 6);
const toVars = (wixTypography) => toEntries(wixTypography).reduce(
  (prev, curr) => __spreadProps(__spreadValues({}, prev), {
    [`font-${curr[0].toLowerCase()}`]: definitionToCssFont(curr[1])
  }),
  {}
);
function createTypography(typography) {
  if (!typography) {
    return {};
  }
  const { fontFamily, wixTypography } = typography;
  const wixTypographyVars = wixTypography ? toVars(wixTypography) : {};
  return Object.assign(wixTypographyVars, fontFamily && { fontFamily });
}
export {
  createTypography as default
};
//# sourceMappingURL=typography.js.map
